import { toast } from "sonner";

import { OperationError } from "@/__generated__/graphql";
import { isUserError } from "@/utils/typeGuards";

export function operationErrorHandler(error: unknown) {
  if (isUserError(error)) {
    const errors: OperationError[] = error.filter(error => error.__typename === "OperationError");
    errors.forEach(mutationError => {
      toast.error("An error occurred", {
        description: mutationError.message,
      });
    });
  } else {
    toast.error("An unexpected error occurred", {
      description: "Please contact Release support if the error persists",
    });
  }
}
